import { useFormikContext } from 'formik';
import { Box, useEventCallback } from '@mui/material';
import { memo } from 'react';
import { CancellationDueDeath } from 'cancellations/view-models/cancellation-due-death';
import { noop } from 'shell/utils/noop';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import { Check, Close } from '@mui/icons-material';
import PmiTooltipError from 'shell/components/shared/tooltip-error';
import { StickyDiv } from 'shell/components/shared/sticky-div';
import { PmiButton } from 'shell/components/shared/button';
import { CodeStepButtonsCancellation } from 'cancellations/constants/code-step-buttons-cancellation';

interface CancellationDueDeathStepButtonsProps {
  onCancel?: () => void;
}

const CancellationDueDeathStepButtonsComponent = ({
  onCancel,
}: CancellationDueDeathStepButtonsProps): React.ReactElement => {
  const formContext = useFormikContext<CancellationDueDeath>();

  const registerStepChange = useEventCallback((activeStep: CodeStepButtonsCancellation) => {
    formContext.setValues({ ...formContext.values, activeStep });
  });

  return (
    <StickyDiv>
      <div>
        <div className="pmi-pb-2">
          <StepButton
            visited={
              formContext.values.activeStep === CodeStepButtonsCancellation.datiCancellazione
            }
            active={formContext.values.activeStep === CodeStepButtonsCancellation.datiCancellazione}
            variant="outlined"
            color="cdmBrandThird"
            fullWidth
            onClick={() => registerStepChange(CodeStepButtonsCancellation.datiCancellazione)}
          >
            {formContext.errors.deathDataForm ||
            formContext.errors.changeControlDataForm ||
            formContext.errors.judgmentDataForm ? (
              <Close color="error" />
            ) : (
              <Check color="success" />
            )}
            <StepTypography
              visited={
                formContext.values.activeStep === CodeStepButtonsCancellation.datiCancellazione
              }
              active={
                formContext.values.activeStep === CodeStepButtonsCancellation.datiCancellazione
              }
            >
              DATI CANCELLAZIONE
            </StepTypography>
          </StepButton>
        </div>
        {formContext.values.showSubjectListSection &&
        Object.keys(formContext.values.subjectListForm?.family || {}).filter((el) => {
          if (formContext.values.deathDataForm?.deathPartnerResident) {
            let marriedSubject;

            if (formContext.values.subjectData?.matrimonio) {
              marriedSubject = formContext.values.subjectData?.matrimonio?.coniuge;
            }

            if (formContext.values.subjectData?.unioneCivile) {
              marriedSubject = formContext.values.subjectData?.unioneCivile?.unitoCivilmente;
            }

            return !(el === marriedSubject?.codiceFiscale?.codFiscale);
          }
          return true;
        }).length > 0 ? (
          <div className="pmi-pb-2">
            <PmiTooltipError
              show={Boolean(formContext.errors.subjectListForm)}
              message={
                Boolean(formContext.errors.subjectListForm) ? 'Inserire elenco soggetti' : ''
              }
            >
              <StepButton
                visited={
                  formContext.values.activeStep === CodeStepButtonsCancellation.elencoSoggetti
                }
                active={
                  formContext.values.activeStep === CodeStepButtonsCancellation.elencoSoggetti
                }
                variant="outlined"
                color="cdmBrandThird"
                fullWidth
                onClick={() => registerStepChange(CodeStepButtonsCancellation.elencoSoggetti)}
              >
                {formContext.errors.subjectListForm ? (
                  <Close color="error" />
                ) : (
                  <Check color="success" />
                )}
                <StepTypography
                  visited={
                    formContext.values.activeStep === CodeStepButtonsCancellation.elencoSoggetti
                  }
                  active={
                    formContext.values.activeStep === CodeStepButtonsCancellation.elencoSoggetti
                  }
                >
                  MODIFICA PARENTELA
                </StepTypography>
              </StepButton>
            </PmiTooltipError>
          </div>
        ) : null}
        <div className="pmi-pb-4">
          <StepButton
            visited={formContext.values.activeStep === CodeStepButtonsCancellation.altriDati}
            active={formContext.values.activeStep === CodeStepButtonsCancellation.altriDati}
            variant="outlined"
            color="cdmBrandThird"
            fullWidth
            onClick={() => registerStepChange(CodeStepButtonsCancellation.altriDati)}
          >
            <StepTypography
              visited={formContext.values.activeStep === CodeStepButtonsCancellation.altriDati}
              active={formContext.values.activeStep === CodeStepButtonsCancellation.altriDati}
            >
              ALTRI DATI
            </StepTypography>
          </StepButton>
        </div>
        <div className="pmi-pb-2">
          <PmiButton
            variant="contained"
            color="cdmBrandThird"
            fullWidth
            type="submit"
            // disabled={!formContext.isValid && formContext.submitCount > 0}
          >
            <Box
              sx={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              CONFERMA
            </Box>
          </PmiButton>
        </div>
      </div>
      <PmiButton variant="contained" color="cdmBrand" fullWidth onClick={onCancel || noop}>
        ANNULLA OPERAZIONE
      </PmiButton>
    </StickyDiv>
  );
};

CancellationDueDeathStepButtonsComponent.displayName = 'Release id card form component';

const CancellationDueDeathStepButtons = memo(CancellationDueDeathStepButtonsComponent);

export default CancellationDueDeathStepButtons;
